export const CAREER_METRICS = [
  {
    value: "14+",
    label: "Years in business + code",
    cta: "My approach",
    act: 0,
  },
  {
    value: "7",
    label: "Years at Fubo",
    cta: "Production impact",
    act: 2,
  },
  {
    value: "OpenAI",
    label: "AI ticket triage",
    cta: "Explore classifier",
    projectId: "support",
  },
  {
    value: "MCP",
    label: "Custom AI tools",
    cta: "Explore systems",
    projectId: "agents",
  },
];

export const WORLD_DESTINATIONS = [
  {
    id: "cinema",
    navLabel: "Cinema",
    title: "Career Cinema",
    kicker: "14+ years across finance + software",
    summary:
      "From financial analysis and founder partnerships to production AI at Fubo and custom agent tooling.",
    position: [-5.3, 0, -2.4],
    camera: [6, 5, 10],
    target: [-5.3, 1.1, -2.4],
  },
  {
    id: "workshop",
    navLabel: "Workshop",
    title: "Tinkerer Workshop",
    kicker: "Production AI + independent products",
    summary:
      "Explore the OpenAI classifier, custom MCP tooling, and independent products. Visit ReliveInColor or get in touch to discuss how the internal systems work.",
    position: [-0.8, 0, -0.8],
    camera: [-7, 6.5, 11],
    target: [-0.8, 1.1, -0.8],
  },
  {
    id: "traveler",
    navLabel: "Traveler",
    title: "Traveler Overlook",
    kicker: "60+ countries",
    summary:
      "Travel as lived experience, product input, and the source material behind travel-focused AI skills and agents.",
    position: [5, 0, -2.7],
    camera: [7, 6, 10],
    target: [5, 1, -2.7],
  },
  {
    id: "publisher",
    navLabel: "Publisher",
    title: "Publisher House",
    kicker: "Books + creative systems",
    summary:
      "A growing shelf for published books and the AI-assisted workflow behind outlining, editing, packaging, and release.",
    position: [4.1, 0, 3.7],
    camera: [7, 5, 11],
    target: [4.1, 1.2, 3.7],
  },
];

export const OVERVIEW_CAMERA = {
  camera: [11, 10, 15],
  target: [0, 0.5, 0],
};
